import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function generateQuotePdf(q) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();

  doc.setFillColor(11, 15, 23);
  doc.rect(0, 0, W, 34, "F");
  doc.setFillColor(245, 183, 0);
  doc.rect(0, 34, W, 1.5, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("Apollo Solar", 15, 18);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Pixa Solar – Apollo.AI · Pixa Web sagl, Via Cantonale 19, 6900 Lugano · IDI/IVA CHE-364.397.948", 15, 24);
  doc.text("sales@pixasolar.online · +41 78 906 27 64 · www.pixasolar.online", 15, 29);
  doc.setFontSize(11);
  doc.text(`PREVENTIVO ${q.number}`, W - 15, 18, { align: "right" });
  doc.setFontSize(9);
  doc.text(new Date(q.created_at || Date.now()).toLocaleDateString("it-IT"), W - 15, 26, { align: "right" });

  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Cliente", 15, 48);
  doc.setFont("helvetica", "normal");
  const client = [q.customer_name, q.customer_address, q.customer_phone, q.customer_email].filter(Boolean);
  client.forEach((line, i) => doc.text(String(line), 15, 54 + i * 5));
  if (q.kwp) {
    doc.setFont("helvetica", "bold");
    doc.text("Impianto", W - 15, 48, { align: "right" });
    doc.setFont("helvetica", "normal");
    doc.text(`${String(q.kwp).replace(".", ",")} kWp`, W - 15, 54, { align: "right" });
  }

  autoTable(doc, {
    startY: 58 + client.length * 5,
    head: [["Descrizione", "Q.tà", "Prezzo unit.", "Totale"]],
    body: q.items.map((i) => [i.description, String(i.qty), eur(i.unit_price), eur(i.qty * i.unit_price)]),
    theme: "grid",
    headStyles: { fillColor: [15, 23, 42], textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 9, cellPadding: 3 },
    columnStyles: { 1: { halign: "right", cellWidth: 18 }, 2: { halign: "right", cellWidth: 32 }, 3: { halign: "right", cellWidth: 32 } },
  });

  let y = doc.lastAutoTable.finalY + 8;
  const totals = [["Imponibile", eur(q.subtotal)], [`IVA ${q.vat_rate}%`, eur(q.vat_amount)], ["TOTALE", eur(q.total)]];
  totals.forEach(([k, v], i) => {
    doc.setFont("helvetica", i === 2 ? "bold" : "normal");
    doc.setFontSize(i === 2 ? 12 : 10);
    doc.text(k, W - 65, y);
    doc.text(v, W - 15, y, { align: "right" });
    y += 7;
  });

  if (q.notes) {
    y += 4;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Note e condizioni", 15, y);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    const lines = doc.splitTextToSize(q.notes, W - 30);
    doc.text(lines, 15, y + 6);
    y += 6 + lines.length * 4.5;
  }

  y = Math.max(y + 20, 250);
  doc.setDrawColor(148, 163, 184);
  doc.line(W - 85, y, W - 15, y);
  doc.setFontSize(9);
  doc.text("Firma per accettazione", W - 50, y + 5, { align: "center" });

  doc.save(`Preventivo_${q.number}_${(q.customer_name || "cliente").replace(/\s+/g, "_")}.pdf`);
}
